/**
 * File: src/i18n/i18n-service.js
 * Mô tả: Dịch vụ quản lý ngôn ngữ (i18n Service), mặc định Tiếng Anh (en), hỗ trợ chuyển đổi Tiếng Việt (vi).
 * Liên quan: src/i18n/translations.js, src/components/header.js
 */

import { translations } from './translations.js';

const STORAGE_KEY = 'snt_user_lang';
const DEFAULT_LANG = 'en';

let currentLang = (() => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === 'vi' || saved === 'en' ? saved : DEFAULT_LANG;
  } catch (e) {
    return DEFAULT_LANG;
  }
})();

document.documentElement.lang = currentLang;
const listeners = new Set();

/**
 * Lấy ngôn ngữ hiện tại ('en' | 'vi')
 * @returns {'en' | 'vi'}
 */
export const getLanguage = () => currentLang;

/**
 * Đặt ngôn ngữ mới và thông báo tới toàn bộ các component
 * @param {'en' | 'vi'} lang 
 */
export const setLanguage = (lang) => {
  if (lang !== 'en' && lang !== 'vi') return;
  if (currentLang === lang) return;

  currentLang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {}

  document.documentElement.lang = lang;
  listeners.forEach((callback) => callback(currentLang));
};

/**
 * Đăng ký lắng nghe sự kiện thay đổi ngôn ngữ
 * @param {Function} callback 
 */
export const onLanguageChange = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

/**
 * Lấy chuỗi dịch theo key path (VD: 'nav.home')
 * @param {string} keyPath 
 * @param {string} [fallback=''] 
 * @returns {string}
 */
export const t = (keyPath, fallback = '') => {
  const keys = keyPath.split('.');
  let dict = translations[currentLang] || translations[DEFAULT_LANG];
  for (const k of keys) {
    if (dict && typeof dict === 'object' && k in dict) {
      dict = dict[k];
    } else {
      // Fallback về English nếu chưa có dịch ở VI
      let fallbackDict = translations[DEFAULT_LANG];
      for (const fk of keys) {
        if (fallbackDict && typeof fallbackDict === 'object' && fk in fallbackDict) {
          fallbackDict = fallbackDict[fk];
        } else {
          return fallback || keyPath;
        }
      }
      return typeof fallbackDict === 'string' ? fallbackDict : fallback || keyPath;
    }
  }
  return typeof dict === 'string' ? dict : fallback || keyPath;
};
